const container = document.querySelector('.customers-register-combo');
const selectRegister = container.querySelector('.form-select__register');
const selectlogin = container.querySelector('.form-select__login');
const registerContainer = container.querySelector('.register');
const loginContainer = container.querySelector('.login');

console.log(123, selectRegister, selectlogin)

selectRegister.addEventListener('click', () => {
  registerContainer.classList.remove('mobile-hide');
  loginContainer.classList.add('mobile-hide');
})
selectlogin.addEventListener('click', () => {
  registerContainer.classList.add('mobile-hide');
  loginContainer.classList.remove('mobile-hide');
})
